import React from 'react';

interface CookieConsentProps {
  onAccept: () => void;
}

const CookieConsent: React.FC<CookieConsentProps> = ({ onAccept }) => (
  <div style={{ background: '#222', color: '#fff', padding: 16, borderRadius: 8, textAlign: 'center' }}>
    <p>
      This website uses cookies to ensure you get the best experience. By continuing to use this site, you accept our use of cookies.
    </p>
    <button style={{ marginTop: 8, padding: '8px 16px', borderRadius: 4, background: '#4caf50', color: '#fff', border: 'none', cursor: 'pointer' }} onClick={onAccept}>
      Accept
    </button>
  </div>
);

export default CookieConsent; 